import { Injectable } from '@angular/core';
import { CastingTypeFormat } from 'src/app/components/att-casting-view/formats/casting-type-formats-sel/casting-type-formats-sel.component';
import { Qualifier } from 'src/app/types/qualifier';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { CastingMode, CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';

@Injectable({
	providedIn: 'root'
})
export class NumberOctalQualifierService implements Qualifier {
	static supportedStats = ['avg','count','first','last','max','median','min','sum','stddev'];
	static ToString(value: number, format: CastingTypeFormat): string {
		switch (format) {
			case 'octal':
				return value.toString(8).trim();
			default:
			case 'octal-c':
				return '0' + value.toString(8).trim();
		}
	}
	static FromString(value: string, format?: CastingTypeFormat): number {
		format = format;
		return parseInt(value, 8);
	}
	public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if (!attribute.casting) {
			return val;
		}
		if (!attribute.casting[castingMode]) {
			return val;
		}
		const casting: CastingValue = attribute.casting[castingMode] as CastingValue;
		switch (attribute.type) {
			case 'text':
			case 'string':
				return val;
			default:
				return NumberOctalQualifierService.ToString(val, casting.format);
		}
	}
	public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if([undefined,null].indexOf(val) > -1) {
			return '';
		}
		return NumberOctalQualifierService.GetDisplayValue(attribute, castingMode, val);
	}
	public static GetNativeValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): any {
		return NumberOctalQualifierService.FromString(value, attribute.casting[castingMode].format);
	}
	public static SupportsStat(statName):boolean {
			return NumberOctalQualifierService.supportedStats.indexOf(statName) > -1;
	}
	constructor() { }
	public static GetNumFormat():string {
		return '@';
	}
}
